export default "<p>\r\n  about-card works!\r\n</p>\r\n"